<div class="modal-dialog">
  <div class="modal-content">
    <div class="modal-header">
      <button type="button" class="close" (click)="cancel()">&times;</button>
      <h4 class="modal-title">{{title || 'Confirmação'}}</h4>
    </div>
    <div class="modal-body">
      <p>{{message || 'Tem certeza de realizar esse operação?'}}</p>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-primary" (click)="confirm()">OK</button>
      <button type="button" class="btn btn-default" (click)="cancel()">Cancel</button>
    </div>
  </div>
</div>
